import React, { Component } from 'react';
import { Popconfirm, Button, message, Modal } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import { InformModify, Detail } from './Widget';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import TableC from '../../basicElement/TableC';
import SideNav from '../SideNav';
import moment from 'moment';

const monthFormat = 'YYYY-MM';

class Filter extends Component {
    handleChange = (params, key) => {
        if (key === 'lineOfBusiness') {
            params.secondLineName = undefined;
            this.props.onChange(params, key);
        } else {
            this.props.onChange(params, key);
        }
    }

    render() {
        const { params, businessList, ...rest } = this.props;
        const { lineOfBusiness } = params;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });
        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const secondLineOption = [...secondLineSet].map(i => ({ value: i, label: i }));

        const filters = [{
            name: '时间',
            key: 'startDate',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '至',
            key: 'endDate',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '录入者',
            key: 'codeName',
            type: 'input',
        }, {
            name: '临床项目',
            key: 'invNameCode',
            type: 'input',
            typeProperty: {
                style: { width: 165 },
            }
        }, {
            name: '中心',
            key: 'siteNameCode',
            type: 'input',
            typeProperty: {
                style: { width: 165 },
            }
        }, {
            name: '角色',
            key: 'roleCode',
            type: 'select',
            typeProperty: {
                list: [
                    { label: 'CTA', value: 'CTA' },
                    { label: 'EA', value: 'EA' },
                    { label: 'BO', value: 'BO' },
                    { label: 'BDO', value: 'BDO' },
                    { label: 'BD', value: 'BD' },
                    { label: 'PA', value: 'PA' },
                    { label: 'PM', value: 'PM' },
                    { label: 'CRC', value: 'CRC' },
                    { label: 'CPM', value: 'CPM' },
                    { label: 'CRCC', value: 'CRCC' },
                    { label: 'CRCM', value: 'CRCM' },
                    { label: 'CPM', value: 'CPM' },
                    { label: 'PI', value: 'PI' },
                    { label: 'CRA', value: 'CRA' },
                    { label: 'OTH', value: 'OTH' },
                ],
            }
        }, {
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption,
            }
        }, {
            name: '执行业务线二级分类',
            key: 'secondLineName',
            type: 'select',
            typeProperty: {
                disabled: !lineOfBusiness,
                list: secondLineOption,
            }
        }];
        return (
            <FilterBasic filters={filters} params={params} {...rest} onChange={this.handleChange} />
        )
    }
}

class ConfirmManhour extends Component {
    constructor(props) {
        super(props);
        const { match: { params } } = props;
        const { relateId, investigation } = params || {};
        const searchParams = {
            startDate: moment().format(monthFormat),
            endDate: moment().format(monthFormat),
        }
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            searchParams,
            curParams: {...searchParams},
            pagination: {
                pageSize: 10,
                current: 1,
            },
            relateId,
            hourType: investigation,
            businessList: [],
        };
    }

    componentDidMount() {
        this.loadData();
        this.queryWithLevelByParams();
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    loadData = () => {
        const { relateId, hourType, sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.manhour.queryUnconfirmedHourList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...curParams,
                relateId,
                hourType,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    data: datas,
                    pagination,
                    loading: false,
                    relateId: '',
                    hourType: '',
                }, () => {
                    if (totalCount > 0 && !(datas || []).length) {
                        pagination.current = current - 1;
                        this.setState({ pagination });
                        this.loadData();
                    }
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: {...searchParams},
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, curParams } = this.state;
        const url = API_URL.export.exportUserFteSummary;
        ExportUtil.export({ ...sortParams, ...curParams }, null, url);
    }

    batchConfirm = () => {
        const { data, curParams, sortParams } = this.state;
        const params = {};
        data.forEach((item, index) => {
            const { hourId, hourType } = item;
            params[`unconfirmedHourViewList[${index}].hourType`] = hourType;
            params[`unconfirmedHourViewList[${index}].hourId`] = hourId;
        });

        const options = {
            url: API_URL.execute.comfirmUserFteMonthOffset,
            data: {
                ...params,
                ...sortParams,
                ...curParams,
            },
            type: 'POST',
            dataType: 'json',
            doneResult: res => {
                if (res.completeInvMessage) {
                    message.info(res.completeInvMessage);
                } else if (res.invJde) {
                    message.info(res.invJde);
                } else if (res.siteJde) {
                    message.info(res.siteJde);
                } else if (res.endTimeOverComment){
                    message.info(res.endTimeOverComment);
                }else if (res.siteContractRelate) {
                    message.error(res.siteContractRelate);
                } else if (res.pmConfirmPercent && res.pmConfirmPercent == '项目完工进度未确认，无法确认工时！'){
                    Modal.warning({
                        content: '部分项目的“截止本月末完工%”=100%，请至我的关注页面进行项目完工进度确认',
                        okText:'确定',
                        onOk: () => {
                            location.href = '/#/home/myFocus';
                        }
                    })
                } else if (res.visitNoHourError) {
                    message.info(res.visitNoHourError);
                } else if (res.noData) {
                    message.info(res.noData);
                } else if (res.success) {
                    message.info(res.success);
                }
                this.loadData();
            },
        };
        $.sendRequest(options);
    }

    markModifyComplete = (record) => {
        const options = {
            method: 'POST',
            url: API_URL.manhour.remarkManHourNoticeModify,
            data: {
                ...record,
                hourType: 'investigation',
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    confirm = record => {
        const { hourId, hourType } = record;
        const options = {
            url: API_URL.execute.comfirmUserFteMonthOne,
            data: {
                hourId,
                hourType,
            },
            dataType: 'json',
            doneResult: res => {
                const { pmConfirmPercent } = res;
                if( pmConfirmPercent ) {
                    Modal.warning({
                        content: '该项目的“截止本月末完工%”=100%，请至我的关注页面进行项目完工进度确认',
                        okText:'确定',
                        onOk: () => {
                            location.href = '/#/home/myFocus';
                        }
                    });
                    return
                }
                message.success('确认成功');
                this.loadData();
            },
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (investigationId, callback) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const canEdit = !(data || []).some(i => {
                    if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                        message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                        return true;
                    } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                        message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                        return true;
                    }  else if (i.operation === 'TERMINATED_BEFORE_CONTRACT') {
                        message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                        return true;
                    }
                    return false;
                });
                this.setState({ loading: false }, () => {
                    if (canEdit) {
                        callback();
                    }
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getColumns = () => {
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 60,
        }, {
            title: '时间',
            dataIndex: 'yearNum',
            key: 'yearNum',
            fixed: 'left',
            sorter: true,
            width: 80,
            render: (text, record) => {
                const { yearNum, monthNum } = record;
                return `${yearNum}-${monthNum}`;
            },
        }, {
            title: '录入者',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            fixed: 'left',
            width: 100,
        }, {
            title: '录入者工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            fixed: 'left',
            width: 100,
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            width: 100,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 180,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineNames',
            key: 'secondLineNames',
            width: 100,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 120,
            render: text => text || '-',
        }, {
            title: '角色',
            dataIndex: 'roleCode',
            key: 'roleCode',
            width: 80,
            sorter: true,
        }, {
            title: '用时/FTE',
            dataIndex: 'fte',
            key: 'fte',
            width: 100,
            render: (text, record) => {
                const { hour } = record;
                return (
                    <a onClick={() => this.showDetail(record)}>{hour.toFixed(2)}h/{text}</a>
                );
            },
        }, {
            title: '实际访视数',
            dataIndex: 'visitCount',
            key: 'visitCount',
            width: 80,
        }, {
            title: '访视数分配系数',
            dataIndex: 'assignWeightShow',
            key: 'assignWeightShow',
            width: 120,
        }, {
            title: '标准访视数',
            dataIndex: 'standardVisitCount',
            key: 'standardVisitCount',
            width: 80,
        }, {
            title: '状态',
            dataIndex: 'statusShow',
            key: 'statusShow',
            width: 120,
        }, {
            title: '操作',
            key: 'operation',
            fixed: 'right',
            width: 120,
            render: (text, record) => {
                const { investigationId } = record;
                return (
                    <span>
                        <Popconfirm title={<span>是否确定此操作?<br/>工时记录确认后，不能再修改！</span>} onConfirm={ investigationId ? ()=>this.canEditByInvStatus(record.investigationId,() => this.confirm(record)) : () => this.confirm(record)} okText="确定" cancelText="取消">
                            <a>确认</a>
                        </Popconfirm>
                        <span className="ant-divider" />
                        <a onClick={ investigationId ? ()=>this.canEditByInvStatus(record.investigationId,() => this.showInformModify(record)) : () => this.showInformModify(record)}>通知修改</a>
                    </span>
                );
            },
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    showDetail = (record) => {
        this.detailRef.show(record);
    }

    showInformModify = (record) => {
        this.informModifyRef.show(record);
    }

    render() {
        const { data, loading, pagination, searchParams, sortParams, businessList } = this.state;
        return (
            <div className="content">
                <SideNav selectKey="confirm" />
                <div className="main">
                    <div className="main-content">
                        <Filter
                            search={this.search}
                            params={searchParams}
                            businessList={businessList}
                            onChange={this.handleFilterChange}
                            buttons={[
                                <Popconfirm key="export" title={<span>是否确定此操作?<br/>工时记录确认后，不能再修改</span>} onConfirm={this.batchConfirm} okText="确定" cancelText="取消">
                                    <Button type="primary">单页批量确认</Button>
                                </Popconfirm>
                            ]}
                        />
                        <TableC
                            data={data}
                            scrollY={500}
                            loading={loading}
                            sortParams={sortParams}
                            columns={this.getColumns()}
                            pagination={pagination}
                            onChange={this.handleTableChange}
                        />
                        <InformModify loadData={this.loadData} ref={el => this.informModifyRef = el} />
                        <Detail loadData={this.loadData} ref={el => this.detailRef = el} />
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfirmManhour;


// WEBPACK FOOTER //
// ./src/components/manHour/confirmManhour/index.js